import React, { useState } from 'react';
import { useIdleTimer } from './use-idle-timer';
import InactivityWarning from './inactivity-warning';
import { performLogout } from '../auth/logout-handler';

interface InactivityManagerProps {
    idleTimeout?: number;
    warningDuration?: number;
    children: React.ReactNode;
}

const InactivityManager: React.FC<InactivityManagerProps> = ({
    idleTimeout = 15 * 60 * 1000, // 15 minutes for production
    warningDuration = 60, // 60 seconds for production
    children
}) => {
    const [showWarning, setShowWarning] = useState(false);

    const handleIdle = () => {
        setShowWarning(true);
    };

    const handleContinue = () => {
        setShowWarning(false);
    };

    const handleLogout = () => {
        performLogout('inactivity');
    };

    useIdleTimer({
        timeout: idleTimeout,
        onIdle: handleIdle,
        enabled: !showWarning
    });

    return (
        <>
            {children}
            <InactivityWarning
                isVisible={showWarning}
                warningDuration={warningDuration}
                onContinue={handleContinue}
                onLogout={handleLogout}
            />
        </>
    );
};

export default InactivityManager;